// Copyright 2016 Sorama B.V.

import { IParameterizedValueConverter } from "aurelia-binding-ext";
import { NotSupportedError } from "errors/NotSupportedError";
import moment from "moment";

export class DateToStringValueConverter implements IParameterizedValueConverter<string, Date, string> {
    public toView(value: Date, parameter: string): string {
        // Make chaining of this converter to a NullToX ValueConverter possible
        if (value === null) {
            return null;
        }

        if (parameter === undefined) {
            parameter = "YYYY-MM-DD HH:mm:ss ";
        }

        return moment(value).format(parameter);
    }

    public fromView(value: string, parameter: string): Date {
        throw new NotSupportedError(
            "Converting a string to a date is not yet supported in the DateToStringValueConverter."
        );
    }
}
